import classNames from "classnames";
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import React, { createRef } from "react";
import { FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { FaFacebookF } from "react-icons/fa6";
import { TbSunMoon } from "react-icons/tb";
import { Outlet } from "react-router-dom";
import { ImagemCapa, ImagemLogo } from "../../components/imagensDinamicas";
import { useTheme } from "../../context/themeContext";
import { MenuPague } from "../../styles/primeReactConfig";

export default function SignupLayout() {
  const menuRef = createRef()
  //const [rerender, setRerender] = useState(false)
  const { itemsTheme } = useTheme()

  function toggleMenu(e) {
    if (!menuRef.current) {
    } else menuRef.current.toggle(e);
  }

  return (
    <div className="grid overflow-auto bg-[#f1f2f3] dark:bg-pague_azul">
      <div className="w-full z-2 grid md:grid-cols-3 sticky 
      h-20 items-center">
        <div className="items-center h-20 flex justify-center md:justify-start">
          <a href="/login" >
            <ImagemLogo />
          </a>
          <Button
            pt={{
              root: classNames(
                "rounded-full bg-black text-white ",
                "dark:text-black dark:bg-white",
                "flex items-center justify-center w-6 h-6",
              ),
              label: "absolute"
            }}
            onClick={toggleMenu}
            icon={<TbSunMoon />}
          />
          <Menu
            popup
            ref={menuRef}
            model={itemsTheme}
            pt={MenuPague}
          />
        </div>
        <div className="lg:flex justify-evenly h-20 hidden text-2xl font-bold items-center">
          <a href="https://direto.tech/" target="_blank" rel="noopener noreferrer">
            <ul>
              <h4>Quem somos</h4>
            </ul>
          </a>
          <a href="https://www.direto.tech/solucoes" target="_blank" rel="noopener noreferrer">
            <ul>
              <h4>Nossas Soluções</h4>
            </ul>
          </a>
          <a href="https://www.direto.tech/sobre" target="_blank" rel="noopener noreferrer">
            <ul>
              <h4>Sobre</h4>
            </ul>
          </a>
        </div>
        <div className="lg:flex justify-end hidden">
          <div className="p-4 mt-2">
            <a href="https://br.linkedin.com/company/diretotech?trk=affiliated-pages"
              className="rounded-full justify-center 
              items-center flex outline outline-2 h-8 w-8 text-xl"
              target="_blank"
              rel="noopener noreferrer" >
              <FaLinkedinIn />
            </a>
          </div>
          <div className="p-4 mt-2">
            <a href="https://www.instagram.com/diretotech/"
              className="rounded-full justify-center 
              items-center flex outline outline-2 h-8 w-8 text-xl"
              target="_blank"
              rel="noopener noreferrer" >
              <FaInstagram />
            </a>
          </div>
          <div className="p-4 mt-2">
            <a href="https://www.facebook.com/direto.tecnologia"
              className="rounded-full justify-center 
              items-center flex outline outline-2 h-8 w-8 text-xl"
              target="_blank"
              rel="noopener noreferrer" >
              <FaFacebookF />
            </a>
          </div>
        </div>
      </div>
      <div className="grid lg:grid-cols-2 h-[calc(100vh-5rem)]" >
        <div className="hidden lg:grid">
          <ImagemCapa/>
        </div>
          <Outlet />
      </div>
    </div>
  );
}